export const DISABLE_SCROLL_TO_TOP = 'DISABLE_SCROLL_TO_TOP';
export const ENABLE_SCROLL_TO_TOP = 'ENABLE_SCROLL_TO_TOP';

export const disableScrollToTopAction = () => ({ type: DISABLE_SCROLL_TO_TOP });
export const enableScrollToTopAction = () => ({ type: ENABLE_SCROLL_TO_TOP });